import { render, staticRenderFns } from "./departmentEdit.vue?vue&type=template&id=ecee6e02&scoped=true"
import script from "./departmentEdit.vue?vue&type=script&lang=js"
export * from "./departmentEdit.vue?vue&type=script&lang=js"
import style0 from "./departmentEdit.vue?vue&type=style&index=0&id=ecee6e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecee6e02",
  null
  
)

export default component.exports